<div [ngClass]="fromClient() ? 'ap-margin-bottom-1' : 'ap-flex ap-margin-bottom-1'" [attr.aria-label]="determineAriaLabel()">
    @if (!fromClient()) {
        <div class="ap-flex-column">
            <div class="ap-flex ap-flex-row">
                @if (showAvatar()) {
                    <ap-illustration [name]="determineAvatar()" [hideTitle]="true" width="42px" height="42px"></ap-illustration>
                } @else {
                    <div [style.min-width.px]="42" [style.min-height.px]="42"></div>
                }
                <ap-chat-bubble class="ap-flex ap-margin-left-2" [alignRight]="fromClient()">
                    <span [innerHTML]="text"></span>
                </ap-chat-bubble>
            </div>
            <message-timestamp [fromClient]="fromClient()" [occurredAtTimestamp]="occurredAt()"></message-timestamp>
        </div>
    }

    @if (fromClient()) {
        <ap-chat-bubble class="ap-flex ap-margin-left-2" [alignRight]="fromClient()">
            <span [innerHTML]="text"></span>
        </ap-chat-bubble>

        <div class="ap-flex ap-justify-content-end">
            <message-timestamp [fromClient]="fromClient()" [occurredAtTimestamp]="occurredAt()"></message-timestamp>
            <message-status [isMessagePending]="isMessagePending()"></message-status>
        </div>
    }
</div>
